import { HeaderTabItemProps } from '@ihsm/ui-shared/lib/typings/shared/components/HeaderTabs/components/HeaderTabItem';
import { REPORTS_CONFIG_REPORT, REPORTS_REPORT, REPORTS_SUMMARY } from 'routes';
import { currentReportSelector } from 'state/store/selectors';
import { useAppSelector } from 'state/store';

export const useHeaderTabs = (): HeaderTabItemProps[] => {
  const report = currentReportSelector(useAppSelector((state) => state));
  const tabs: HeaderTabItemProps[] = [];

  if (report) {
    tabs.push({ displayValue: 'Config', path: REPORTS_CONFIG_REPORT });
  }

  if (report?.jobId && report.jobTimestamp) {
    tabs.unshift({ displayValue: 'Report', path: REPORTS_REPORT });
    tabs.unshift({ displayValue: 'Summary', path: REPORTS_SUMMARY });
  }

  return tabs;
};
